import type { Ref } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import type { Player } from '@modules/players/types';
import type { ITableDataResponse, ITableState } from '@modules/tables/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { PLAYERS_LIST_API_URL, PLAYERS_LIST_QUERY_KEY, PLAYERS_PERMISSIONS } from '@modules/players/constants';
import { keepPreviousData } from '@tanstack/vue-query';

export default function usePlayersListQuery(tableState: Ref<ITableState>): IContextQueryResult<
  ITableDataResponse<Player>,
  Error
> {
  const { fetchPost } = useRestClient();

  return useContextQuery<ITableDataResponse<Player>>({
    queryKey: [PLAYERS_LIST_QUERY_KEY, tableState],
    queryFn: ({ signal }) => fetchPost<ITableDataResponse<Player>>(
      PLAYERS_LIST_API_URL,
      tableState.value,
      {
        signal,
        permission: PLAYERS_PERMISSIONS.PLAYERS_SHOW,
      },
    ),
    placeholderData: keepPreviousData,
  });
}
